const ImagesSite = require("@/modules/images/components/ImagesSite.vue")
  .default;

const ImageRoutes = [
  {
    name: "images.images",
    path: "/images-collection",
    component: ImagesSite,
    meta: {
      requiresAuth: true,
    },
  },
];

const ImageSettingsRoutes = [];

const ImageBaseDataRoutes = [];

export { ImageRoutes, ImageSettingsRoutes, ImageBaseDataRoutes };
